import {
  ProductAccessReason,
  ProductsAndAccessResult,
} from '#types/generated/graphql-types';

export default function shouldShowPlayButton(
  products: ProductsAndAccessResult
) {
  const hasProducts = products?.availableProducts?.length > 0;
  const access = products?.access;

  if (hasProducts && access?.allowed === true) {
    return true;
  }

  return (
    access?.reason === ProductAccessReason.UserPinRequired ||
    access?.reason === ProductAccessReason.UserPinNotConfigured ||
    access?.reason === ProductAccessReason.LoginRequired
  );
}
